import React, { Component } from 'react'
import ReactPlayer from 'react-player/youtube'
import styled from 'styled-components'

import media from 'utils/media'

// import playButton from 'assets/svg/play-button-2.svg'

class YouTube extends Component {
   state = {
      playing: false,
      turnOnByUser: false,
   }

   handleVideoPlay = () => this.setState({ playing: true, turnOnByUser: true })

   render() {
      // const imageId = this.props.src.slice(this.props.src.lastIndexOf('/') + 1)

      return (
         <StyledYouTube className="youtube-box">
            {/* <Thumbnail imageUrl={`https://i.ytimg.com/vi/${imageId}/hqdefault.jpg`} hidden={this.state.turnOnByUser}>
               <button onClick={this.handleVideoPlay}>
                  <img src={playButton} alt="Play Video" />
               </button>
            </Thumbnail> */}
            <ReactPlayer
               url={this.props.src}
               width="100%"
               height="100%"
               className="react-player"
               playing={this.state.playing}
               config={{
                  youtube: {
                     playerVars: { showinfo: 0, controls: 1, modestbranding: 1, rel: 0 },
                  },
               }}
            />
         </StyledYouTube>
      )
   }
}

export default YouTube

const StyledYouTube = styled.div`
   position: relative;
   padding-top: 56.25%;
   margin-bottom: 26px;

   ${media.greaterThan('lg')`
      margin: 3.5rem auto;
   `};

   .react-player {
      position: absolute;
      top: 0;
      left: 0;
   }
`

const Thumbnail = styled.div`
   display: ${({ hidden }) => (hidden ? 'none' : 'inline-block')};
   position: absolute;
   top: 0;
   left: 0;
   z-index: 2;
   width: 100%;
   height: 100%;
   background-image: url(${({ imageUrl }) => imageUrl});
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;

   button {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: transparent;
      border: none;
      cursor: pointer;
      padding: 0;
      transition: opacity 0.15s ease-in-out;

      img {
         width: 20px;
         height: 26px;
         margin: 0;
         position: absolute;
         left: 23px;
         bottom: 18px;
      }
   }

   &:hover button {
      opacity: 0.7;
   }
`
